import { DefaultApiFactory } from "./api/api"
import { Configuration } from "./api/configuration"

export const API_ENDPOINT = 'zapper-api'

const getBasePath = () : string => {
    if ((window.location.hostname=='127.0.0.1') || (window.location.hostname=='localhost')) {
        return 'http://' + window.location.hostname + ':13002'
    }
    const domains = window.location.hostname.split('.')
    domains[0] = API_ENDPOINT
    let url = 'https://' + domains.join('.')
    if (window.location.port != '443') {
        url += `${window.location.port}`
    }
    return url
}

export const getApi = () => {
    const config = new Configuration({
        basePath: getBasePath()
    })
    return DefaultApiFactory(config)
}
